import { ExternalLink } from "lucide-react";

const SquareMark = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="4" fill="none" stroke="currentColor" strokeWidth="2.4" />
    <rect x="8" y="8" width="8" height="8" rx="1.2" fill="currentColor" />
  </svg>
);

export const isSquareLink = (link) => /square/i.test(link || "");

export const PayButton = ({ link, label, testid }) => {
  const square = isSquareLink(link);
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="group inline-flex items-center gap-2 mt-2 px-4 py-2 bg-[#0a0a0a] text-[#C9963F] text-xs font-medium tracking-wide border border-[#C9963F]/60 hover:bg-[#C9963F] hover:text-black transition-colors duration-200"
    >
      {square ? <SquareMark /> : <ExternalLink size={13} />}
      <span>{square ? "Pay with Square" : "Pay Online"}</span>
      {label && <span className="text-white/50 group-hover:text-black/60 transition-colors">· {label}</span>}
    </a>
  );
};
